export const formDataResponseHandler = (response: Response) => {
  return response.formData();
};
